import type { OrderSummaryBasket } from '@/components/order-summary/mobile-heading-utils';

/**
 * Promotion ID used by the `dw.order.calculate` hook to tag the sold-by-weight
 * authorization surcharge shipping price adjustment. Must match the value in
 * `cartridges/app_project/cartridge/scripts/helpers/soldByWeightSurcharge.js`.
 */
export const SOLD_BY_WEIGHT_SURCHARGE_PROMOTION_ID = 'soldByWeightAuthorization';

/**
 * Finds the sold-by-weight authorization surcharge amount on a basket or order.
 *
 * The surcharge is created server-side as a positive shipping price adjustment,
 * so it is already included in `shippingTotal`. Consumers should subtract the
 * returned amount from the displayed shipping cost and render it as its own row.
 *
 * @param basket - the basket or order to inspect
 * @returns the surcharge amount, or `undefined` when no surcharge is present
 */
export function getSoldByWeightSurchargeAmount(basket: OrderSummaryBasket | undefined): number | undefined {
    if (!basket?.shippingItems) {
        return undefined;
    }

    for (const shippingItem of basket.shippingItems) {
        const adjustment = shippingItem.priceAdjustments?.find(
            (priceAdjustment) => priceAdjustment.promotionId === SOLD_BY_WEIGHT_SURCHARGE_PROMOTION_ID
        );
        if (adjustment && typeof adjustment.price === 'number') {
            return adjustment.price;
        }
    }

    return undefined;
}
